/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { responsesPartMeta } from '../models/responsesPartMeta';
import type { user } from '../models/user';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UsersProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get a user's profile
   * @param requestBody
   * @returns any User record
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersContext(
    requestBody?: {
      /**
       * UUID of the user to retrieve
       */
      userUuid: string;
      /**
       * UUID of the company context
       */
      companyUuid: string;
    },
  ): CancelablePromise<{
    data?: user;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/context',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * generate a workerPageToken and send an email with the link to the worker's page
   * @param requestBody
   * @returns any A payload with up to two information: sent boolean, true if an email containing the worker's personal page link was sent, error property if any error occurred during the process
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserSendPortalLinkContext(
    requestBody?: {
      slug: string;
    },
  ): CancelablePromise<{
    data?: {
      sent?: boolean;
      error?: Record<string, any>;
      loginLink?: string;
      obfuscatedEmail?: string;
      tokenDurationInMinutes?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/send-portal-link/context',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * start registration process for a new user
   * @param requestBody
   * @returns any A payload with up an init boolean, true if the registration process started successfully
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserPreregister(
    requestBody?: {
      turnstileToken?: string;
      firstname?: string;
      lastname?: string;
      email: string;
      company?: {
        name: string;
        brand?: {
          websiteUrl?: string;
        };
        companyType?: 'active' | 'internal' | 'pilot' | 'demo';
      };
    },
  ): CancelablePromise<{
    data?: {
      init?: boolean;
      sent?: boolean;
      error?: Record<string, any>;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/preregister',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Start new user and company registration process from other platform applications
   * @param xApiKey Hire account superuser token; company.metadata is honored only when it matches the X-Router entry
   * @param requestBody
   * @returns any Company successfully created
   * @throws ApiError
   */
  public postApiServicesecurityProcessesHireRegisterNewCompany(
    xApiKey?: string,
    requestBody?: {
      firstname?: string;
      lastname?: string;
      email: string;
      sendInitEmail?: boolean;
      timezone?: string;
      locale?: string;
      selfServeRequestId?: string;
      brand?: {
        logo_url?: string;
        primary_color?: string;
        secondary_color?: string;
      };
      company?: {
        name: string;
        hireAccountUuid?: string;
        hireAccountBaseUrl?: string;
        hireAccountApiKey?: string;
        hireAccountSlug?: string;
        unifiedAuth?: boolean;
        unifiedAccess?: boolean;
        tfaRequired?: boolean;
        inactivityLockDays?: number;
        hasHireGoAccount?: boolean;
        brand?: {
          websiteUrl?: string;
        };
        selfServeRequestId?: string;
        /**
         * Self-serve selection applied to the new company. Honored only when X-API-KEY matches the X-Router entry.
         */
        metadata?: Record<string, any>;
      };
    },
  ): CancelablePromise<{
    /**
     * true
     */
    init?: boolean;
    /**
     * 023f31a2-84d5-4eed-b42d-1d84f579d2c7
     */
    companyUuid?: string;
    /**
     * 023f31a2-84d5-4eed-b42d-1d84f579d2c7
     */
    userAudienceUuid?: string;
    /**
     * 023f31a2-84d5-4eed-b42d-1d84f579d2c7
     */
    userUuid?: string;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/hire/registerNewCompany',
      headers: {
        'X-API-KEY': xApiKey,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        409: `Duplicate email`,
      },
    });
  }

  /**
   * Start new user and company registration process from other platform applications
   * @param requestBody
   * @returns any Company successfully associated
   * @throws ApiError
   */
  public postApiServicesecurityProcessesHireAssociateWxCompanyWithHireAccount(
    requestBody?: {
      email: string;
      wxCompanyUuid?: string;
      company?: {
        hireAccountUuid?: string;
        hireAccountBaseUrl?: string;
        hireAccountApiKey?: string;
        hireAccountSlug?: string;
        unifiedAuth?: boolean;
        tfaRequired?: boolean;
        inactivityLockDays?: number;
        hasHireGoAccount?: boolean;
        brand?: {
          websiteUrl?: string;
        };
      };
    },
  ): CancelablePromise<{
    error?: string;
    /**
     * 023f31a2-84d5-4eed-b42d-1d84f579d2c7
     */
    companyUuid?: string;
    /**
     * 023f31a2-84d5-4eed-b42d-1d84f579d2c7
     */
    userAudienceUuid?: string;
    /**
     * 023f31a2-84d5-4eed-b42d-1d84f579d2c7
     */
    userUuid?: string;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/hire/associateWXCompanyWithHireAccount',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * end registration process for a new user
   * @param requestBody
   * @returns any Process status. "userStatus" to know the status of the user after process end, "invalidPassword" if password is invalid (i.e: not string enough), "isPasswordLeaked" if the password appears in a known breach corpus (Have I Been Pwned; pick a different password), "invalidToken" if token is not valid (anymore), "expiredToken" if the token is well-formed but past its 7-day expiry (request a new invite), "initialized" to know if process ended successfully
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserRegister(
    requestBody?: {
      userUuid: string;
      token: string;
      password: string;
      firstname?: string;
      lastname?: string;
    },
  ): CancelablePromise<{
    data?: {
      userStatus?: 'ok' | 'disabled' | 'init' | 'terminated';
      invalidPassword?: boolean;
      isPasswordLeaked?: boolean;
      invalidToken?: boolean;
      expiredToken?: boolean;
      initialized?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/register',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * get branding context for registration completion (init) screen
   * @param requestBody
   * @returns any Display name and logo URL for the employer registration screen
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserRegistrationContext(
    requestBody: {
      userUuid: string;
      token: string;
    },
  ): CancelablePromise<{
    data?: {
      /**
       * Company or brand name to show
       */
      displayName?: string;
      /**
       * Logo URL when available
       */
      logoUrl?: string | null;
      /**
       * User first name for the greeting
       */
      firstname?: string;
      /**
       * Work email (read-only on the init form)
       */
      email?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/registration-context',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `default error response`,
        404: `default error response`,
      },
    });
  }

  /**
   * start registration process for a new user
   * @param code open signup company code
   * @param requestBody
   * @returns any A payload with up an init boolean, true if the registration process started successfully
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserOpensignupPreregister(
    code: string,
    requestBody?: {
      turnstileToken?: string;
      firstname?: string;
      lastname?: string;
      email: string;
    },
  ): CancelablePromise<{
    data?: {
      init?: boolean;
      sent?: boolean;
      error?: Record<string, any>;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/opensignup/{code}/preregister',
      path: {
        'code': code,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * get user login pre-information
   * Get user login pre-information. Know if a user should be authenticated by the SSO of an organization or by classic password. This route is anonymous and deliberately reports neither whether an account exists nor its status, so it cannot be used to enumerate accounts: an unknown address and a password account both return "sso": null.
   * @param requestBody
   * @returns any Login pre-information. "sso" carries the SSO address and information when the address belongs to an SSO-configured account, and is null otherwise — including for an address with no account at all. The client always presents the password step when "sso" is null.
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserPrelogin(
    requestBody?: {
      email: string;
    },
  ): CancelablePromise<{
    data?: {
      sso?: {
        enabled?: boolean;
        loginUrl?: string;
      };
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/prelogin',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Generate a registration link for a user
   * Generate a registration link for an existing user without sending an email. Used for self-serve account creation where we want to show the link immediately.
   * @param requestBody
   * @returns any Successfully generated register link
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserGenerateRegisterLink(
    requestBody?: {
      email: string;
      /**
       * If true, also send the EmployerInitAccount email with the register link (used by the enterprise-admin createCompany flow).
       */
      sendEmail?: boolean;
    },
  ): CancelablePromise<{
    data?: {
      registerUrl?: string;
      userUuid?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/generateRegisterLink',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `User not found with the given email`,
      },
    });
  }

  /**
   * submit otp as part of TFA user login
   * Submit TOTP along with encrypted password as part of TFA user login
   * @param requestBody
   * @returns any OTP submission response. An unknown address, a wrong password and a wrong code all return the same `connected: false` payload with this status, so the route cannot be used to enumerate accounts.
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersOtp(
    requestBody?: {
      email: string;
      otp: string;
      password: string;
    },
  ): CancelablePromise<{
    data?: {
      connected?: boolean;
      token?: string;
      audience?: string;
      userUuid?: string;
      invalidOtp?: boolean;
      /**
       * True when OTP verification is locked after too many failed attempts
       */
      isOtpLocked?: boolean;
      /**
       * Seconds until the OTP lockout expires (present when isOtpLocked is true)
       */
      retryAfter?: number | null;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/otp',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * login user
   * Login user using a classic email and password.
   * @param requestBody
   * @returns any A payload with up to three information: `connected` boolean, true if the login is successful, `token` string, the JWT token if login is successful, `userUuid` string, the user's uuid. Existence is deliberately not reported: an unknown address and a known address with the wrong password return the same `connected: false` payload, so this route cannot be used to enumerate accounts.
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserLogin(
    requestBody?: {
      email: string;
      password: string;
      /**
       * When account has been locked due to inactivity, this token lets them unlock it.
       */
      unlockToken?: string;
      /**
       * Cloudflare turnstile token to validate
       */
      turnstileToken?: string;
      /**
       * The URL the user will be redirected to after login. Used to determine the external validation source (Hire Go vs Monolith).
       */
      redirectTo?: string;
    },
  ): CancelablePromise<{
    data?: {
      connected?: boolean;
      isLocked?: boolean;
      isLockedDueToInactivity?: boolean;
      isPasswordExpired?: boolean;
      isPasswordLeaked?: boolean;
      token?: string;
      needsTfaSetup?: boolean;
      qrCodeUrl?: string;
      tfaData?: {
        qrCodeUrl?: string;
        secret?: string;
        user: {
          email?: string;
        };
      };
      awaitingOtpCode?: boolean;
      audience?: string;
      userUuid?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/login',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * login user by uuid
   * Login user using the user uuid and password.
   * @param userIdentifier user unique identifier
   * @param requestBody
   * @returns any A payload with up to four information: `exists` boolean, true if the user is found, `connected` boolean, true if the login is successful, `token` string, the JWT token if login is successful, `userUuid` string, the user's uuid
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersLogin(
    userIdentifier: string,
    requestBody?: {
      password: string;
    },
  ): CancelablePromise<{
    data?: {
      exists?: boolean;
      connected?: boolean;
      token?: string;
      userUuid?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/{userIdentifier}/login',
      path: {
        'userIdentifier': userIdentifier,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * user change password
   * User change password process Logged-in user can change his password using his current password.
   * @param requestBody
   * @returns any Process status. "invalidNewPassword" if new password if not strong of new enough, "invalidOldPassword" if old password is not correct, "isPasswordLeaked" if the new password appears in a known breach corpus (Have I Been Pwned; pick a different password), "changed" password have been successfully changed.
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserPasswordChange(
    requestBody?: {
      oldPassword: string;
      newPassword: string;
    },
  ): CancelablePromise<{
    data?: {
      invalidNewPassword?: boolean;
      invalidNewPasswordReuse?: boolean;
      invalidOldPassword?: boolean;
      isPasswordLeaked?: boolean;
      changed?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/password/change',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * start password reset process
   * Start password reset process. If user is allowed to be reset, send an emailto user with reset instructions.
   * @param requestBody
   * @returns any Always `{ "sent": true }`, whatever the outcome — no account for this address, a real account, an SSO account that cannot reset, or a send failure. The route reports nothing that would tell an anonymous caller whether the address has an account. It used to answer "exists", "status" and "sso", and a 503 naming the identity provider; all four were an account-enumeration oracle.
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserPasswordPrereset(
    requestBody?: {
      email: string;
      turnstileToken?: string;
    },
  ): CancelablePromise<{
    data?: {
      sent?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/password/prereset',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * end password reset process
   * @param requestBody
   * @returns any Process status. "userStatus" status of the user after process end, "invalidNewPassword" if new password if invalid (i.e: not strong enough), "invalidNewPasswordReuse" if new password has already been used before, "isPasswordLeaked" if the new password appears in a known breach corpus (Have I Been Pwned; pick a different password), "invalidToken" if  token is not valid (anymore), "isTokenExpired" if the reset token has expired (older than the configured window; default 1 hour, PASSWORD_RESET_TOKEN_EXPIRES_MIN), "changed" password have been successfully changed.
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserPasswordReset(
    requestBody?: {
      userUuid: string;
      token: string;
      password: string;
    },
  ): CancelablePromise<{
    data?: {
      invalidNewPassword?: boolean;
      invalidNewPasswordReuse?: boolean;
      isPasswordLeaked?: boolean;
      invalidToken?: boolean;
      isTokenExpired?: boolean;
      changed?: boolean;
      userStatus?: 'ok' | 'disabled' | 'init' | 'terminated';
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/password/reset',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * generate a workerPageToken and send an email with the link to the worker's page
   * @param requestBody
   * @returns any A payload with up to two information: sent boolean, true if an email containing the worker's personal page link was sent, error property if any error occurred during the process
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserSendPersonalLink(
    requestBody?: {
      turnstileToken?: string;
      slug: string;
      next?: string;
      papiAccountOption?: string;
    },
  ): CancelablePromise<{
    data?: {
      sent?: boolean;
      error?: Record<string, any>;
      loginLink?: string;
      obfuscatedEmail?: string;
      tokenDurationInMinutes?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/send-personal-link',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * log a worker password-less via his personal page token
   * @param requestBody
   * @returns any A payload with up to five information: token, the jwt token granting access to the worker refreshToken, the refresh token to get a new token invalidUserToken, boolean, false if the token is not matching our DB tokenexpiredToken, boolean, true if the token has expireduserIdentifier, the identifier of the worker if login is successful
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserWorkerLogin(
    requestBody?: {
      userUuid: string;
      slug: string;
      token: string;
    },
  ): CancelablePromise<{
    data?: {
      token?: string;
      refreshToken?: string;
      invalidUserToken?: boolean;
      expiredToken?: boolean;
      userIdentifier?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/worker/login',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Issue a short-lived provisional token (<= 2h) for a user (audienceUuid + email + companyUuid) in order to auth tool calls from Fountain-AI
   * @param faiApiKey Fountain-AI API key to authorize issuing provisional tokens
   * @param requestBody
   * @returns any Returns a short-lived JWT for the identified user (no refresh token).
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserFaiProvisionalToken(
    faiApiKey: string,
    requestBody?: {
      audienceUuid: string;
      email: string;
      companyUuid: string;
      /**
       * Optional. When set to "agent", the issued token carries an agent audience and the company agent role instead of the resolved user's own audience/role, with impersonatedBy set to the company system user. Omit for legacy behavior.
       */
      tokenType?: 'agent';
    },
  ): CancelablePromise<{
    data?: {
      token?: string;
      userUuid?: string;
      tenantUuid?: string;
      audience?: 'worker' | 'employer' | 'agent';
      audienceUuid?: string;
      expiresAt?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/fai-provisional-token',
      headers: {
        'fai-api-key': faiApiKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Issue a short-lived system token (<= 1h) for a company in order to auth system-level tool calls from Fountain-AI
   * @param faiApiKey Fountain-AI API key to authorize issuing system tokens
   * @param requestBody
   * @returns any Returns a short-lived SYSTEM-audience JWT (no refresh token).
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserFaiSystemToken(
    faiApiKey: string,
    requestBody?: {
      companyUuid: string;
    },
  ): CancelablePromise<{
    data?: {
      token?: string;
      expiresAt?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/fai-system-token',
      headers: {
        'fai-api-key': faiApiKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * send an OTP to the worker's phone
   * @param requestBody
   * @returns any sent boolean, true if an email containing the worker's personal page link was sent, error property if any error occurred during the process, a client code to be sent back with the verification code received by SMS
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserSendOtp(
    requestBody?: {
      turnstileToken?: string;
      slug: string;
    },
  ): CancelablePromise<{
    data?: {
      sent?: boolean;
      error?: Record<string, any>;
      clientCode?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/sendOtp',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * verify an OTP previously sent to the user
   * @param requestBody
   * @returns any the token to let the user continue with login
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserVerifyOtp(
    requestBody?: {
      slug: string;
      otp: string;
      clientCode: string;
    },
  ): CancelablePromise<{
    data?: {
      token?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/verifyOtp',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * log out a worker from the current device, can logout from all devices with an option
   * @param requestBody
   * @returns any A success boolean
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserLogout(
    requestBody?: {
      options?: {
        /**
         * If true, will revoke every JWT associated to the user
         */
        everywhere?: boolean;
      };
    },
  ): CancelablePromise<{
    data?: {
      success?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/logout',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * log out the given user from all devices
   * @param userIdentifier user unique identifier
   * @returns any A success boolean
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersForcelogout(
    userIdentifier: string,
  ): CancelablePromise<{
    data?: {
      success?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/{userIdentifier}/forcelogout',
      path: {
        'userIdentifier': userIdentifier,
      },
    });
  }

  /**
   * log out every user in the given company from all devices
   * @param companyIdentifier company unique identifier
   * @returns any Force-logout job accepted for asynchronous processing
   * @throws ApiError
   */
  public postApiServicesecurityProcessesCompaniesForcelogout(
    companyIdentifier: string,
  ): CancelablePromise<{
    data?: {
      queued?: boolean;
      correlation?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/companies/{companyIdentifier}/forcelogout',
      path: {
        'companyIdentifier': companyIdentifier,
      },
    });
  }

  /**
   * invalidate the stored password of every user in the given company
   * @param companyIdentifier company unique identifier
   * @returns any Password-reset job accepted for asynchronous processing
   * @throws ApiError
   */
  public postApiServicesecurityProcessesCompaniesResetPasswords(
    companyIdentifier: string,
  ): CancelablePromise<{
    data?: {
      queued?: boolean;
      correlation?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/companies/{companyIdentifier}/reset-passwords',
      path: {
        'companyIdentifier': companyIdentifier,
      },
    });
  }

  /**
   * log out the given employer from all devices
   * @param employerIdentifier employer unique identifier
   * @returns any A success boolean
   * @throws ApiError
   */
  public postApiServicesecurityProcessesEmployersForcelogout(
    employerIdentifier: string,
  ): CancelablePromise<{
    data?: {
      success?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/employers/{employerIdentifier}/forcelogout',
      path: {
        'employerIdentifier': employerIdentifier,
      },
    });
  }

  /**
   * log out the given worker from all devices
   * @param workerIdentifier worker unique identifier
   * @returns any A success boolean
   * @throws ApiError
   */
  public postApiServicesecurityProcessesWorkersForcelogout(
    workerIdentifier: string,
  ): CancelablePromise<{
    data?: {
      success?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/workers/{workerIdentifier}/forcelogout',
      path: {
        'workerIdentifier': workerIdentifier,
      },
    });
  }

  /**
   * Regenerate an employer init token and resend an email to this employer
   * @param employerIdentifier employer unique identifier
   * @returns any A success boolean
   * @throws ApiError
   */
  public postApiServicesecurityProcessesEmployersReinvite(
    employerIdentifier: string,
  ): CancelablePromise<{
    data?: {
      success?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/employers/{employerIdentifier}/reinvite',
      path: {
        'employerIdentifier': employerIdentifier,
      },
    });
  }

  /**
   * Regenerate a user init token and resend an email to this user
   * @param userIdentifier user unique identifier
   * @returns any A success boolean
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersReinvite(
    userIdentifier: string,
  ): CancelablePromise<{
    data?: {
      success?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/{userIdentifier}/reinvite',
      path: {
        'userIdentifier': userIdentifier,
      },
    });
  }

  /**
   * Reset users two-factor authentication
   * @param userIdentifier user unique identifier
   * @returns any A success boolean
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersResetTfa(
    userIdentifier: string,
  ): CancelablePromise<{
    data?: {
      success?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/{userIdentifier}/reset_tfa',
      path: {
        'userIdentifier': userIdentifier,
      },
    });
  }

  /**
   * Send user inactivity unlock email or force unlock the account
   * @param userIdentifier user unique identifier
   * @param forceUnlock whether to force unlock the account, in which case the user will be unlocked without sending an email
   * @returns any A success boolean
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersInactivityUnlock(
    userIdentifier: string,
    forceUnlock: boolean = false,
  ): CancelablePromise<{
    data?: {
      success?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/{userIdentifier}/inactivityUnlock',
      path: {
        'userIdentifier': userIdentifier,
      },
      query: {
        'forceUnlock': forceUnlock,
      },
    });
  }

  /**
   * Admin-triggered password reset - send a reset email to a company's own employer
   * Authenticated equivalent of `/processes/user/password/prereset`, used by admins to trigger a password reset for another user in their own company (e.g. from the employer settings user menu). Requires no Cloudflare Turnstile token since the caller is already authenticated and authorized.
   * @param userIdentifier user unique identifier
   * @returns any Process status. "exists" if no user exists with this identifier, "sent" reset mail is sent, process ended, "sso" if user should be connected using  SSO (can not reset), "status" to know user status (only "ok" status is allowed to reset user password).
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersPasswordPrereset(
    userIdentifier: string,
  ): CancelablePromise<{
    data?: {
      exists?: boolean;
      sent?: boolean;
      sso?: boolean;
      status?: 'ok' | 'disabled' | 'init' | 'terminated';
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/{userIdentifier}/password/prereset',
      path: {
        'userIdentifier': userIdentifier,
      },
    });
  }

  /**
   * Retrieve a short-lived authenticated URL for a worker's portal
   * Impersonate a user in their own portal.
   * @param workerUuid worker uuid
   * @returns any The worker portal url including the authentication token
   * @throws ApiError
   */
  public getApiServicesecurityProcessesUsersImpersonate(
    workerUuid: string,
  ): CancelablePromise<{
    data?: {
      loginLink?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/users/{workerUuid}/impersonate',
      path: {
        'workerUuid': workerUuid,
      },
    });
  }

  /**
   * Retrieve a short-lived authenticated URL for a worker's portal
   * Impersonate a user in their own portal.
   * @param workerUuid worker uuid
   * @param embeddedSession whether this action is requested for an embedded portal session
   * @returns any The worker portal url including the authentication token
   * @throws ApiError
   */
  public getApiServicesecurityProcessesWorkersImpersonate(
    workerUuid: string,
    embeddedSession?: boolean,
  ): CancelablePromise<{
    data?: {
      loginLink?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/workers/{workerUuid}/impersonate',
      path: {
        'workerUuid': workerUuid,
      },
      query: {
        'embeddedSession': embeddedSession,
      },
    });
  }

  /**
   * Retrieve a short-lived authenticated URL for a worker's portal
   * Impersonate a user in their own portal.
   * @param employerUuid worker uuid
   * @returns any The impersonated employer JWT token
   * @throws ApiError
   */
  public getApiServicesecurityProcessesEmployersImpersonate(
    employerUuid: string,
  ): CancelablePromise<{
    data?: {
      token?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/employers/{employerUuid}/impersonate',
      path: {
        'employerUuid': employerUuid,
      },
    });
  }

  /**
   * Mint a WX employer JWT scoped to a Hire account's WX company for an enterprise identity
   * This endpoint is called by the Fountain Hire IntegrationsController#wx_jwt when the WX JWT stored in the Hire session names a different company than the account being viewed. The Hire caller is already scoped to that account by its per-account XRouter secrets, so the JWT's company IS the target account. Only the system account with email 'system@fountain.com' is authorized to call this endpoint, and its JWT company must equal targetCompanyIdentifier. Token TTL follows JWT_TTL_EMPLOYER.
   * @param targetCompanyIdentifier WX company uuid of the Hire account being viewed
   * @param requestBody
   * @returns any A payload with token+userUuid on success, both null when the identity has no employer row on the target company
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersHireAccountToken(
    targetCompanyIdentifier: string,
    requestBody: {
      /**
       * Email of the enterprise identity for whom to mint an employer JWT on the target company
       */
      email: string;
    },
  ): CancelablePromise<{
    data?: {
      token?: string | null;
      userUuid?: string | null;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/hire-account-token/{targetCompanyIdentifier}',
      path: {
        'targetCompanyIdentifier': targetCompanyIdentifier,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Generate a WX JWT for Hire superuser impersonation (employer users only)
   * This endpoint is used exclusively by the Fountain Hire superuser impersonation flow to obtain a WX user-scoped JWT for a specific employer user. The token is intended for client-side auth inside Hire (eg. 'WxNavbar', 'WxCopilot'). Only the system account with email 'system@fountain.com' is authorized to call this endpoint. Do NOT reuse this endpoint for other automation or impersonation use cases without Fountain One review. Only employer users can be impersonated and the token TTL follows `JWT_TTL_EMPLOYER`.
   * @param userIdentifier UUID of the employer user to impersonate
   * @returns any The impersonated employer user JWT token
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersHireSuperuserImpersonate(
    userIdentifier: string,
  ): CancelablePromise<{
    data?: {
      token?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/{userIdentifier}/hire-superuser-impersonate',
      path: {
        'userIdentifier': userIdentifier,
      },
      errors: {
        401: `Unauthorized - missing or invalid JWT`,
        403: `Forbidden - impersonation is only allowed for employer users`,
        404: `User not found`,
      },
    });
  }

  /**
   * Issue company tokens for an enterprise identity user
   * @param companyIdentifier company uuid
   * @returns any A payload with up to four information: `exists` boolean, true if the user is found, `connected` boolean, true if the login is successful, `token` string, the JWT token if login is successful, `userUuid` string, the user's uuid
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersIssueCompanyToken(
    companyIdentifier: string,
  ): CancelablePromise<{
    data?: {
      exists?: boolean;
      connected?: boolean;
      token?: string;
      userUuid?: string;
      /**
       * Refresh token for renewing the company-scoped JWT
       */
      refreshToken?: string | null;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/issueCompanyToken/{companyIdentifier}',
      path: {
        'companyIdentifier': companyIdentifier,
      },
    });
  }

  /**
   * Get a list of company identities for a given user
   * @returns any A list of company identities for the user
   * @throws ApiError
   */
  public getApiServicesecurityProcessesEnterpriseIdentityCompanyIdentities(): CancelablePromise<{
    data?: Array<{
      userUuid?: string;
      company?: {
        uuid?: string;
        name?: string;
        mainLogoUrl?: string;
      };
    }>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/enterprise-identity/companyIdentities',
    });
  }

  /**
   * Resolve whether the current employer should submit a different company JWT to Hire
   * @returns any Whether a company-token switch is needed for the Hire redirect
   * @throws ApiError
   */
  public getApiServicesecurityProcessesHireResolveCanonicalCompany(): CancelablePromise<{
    data?: {
      switchNeeded?: boolean;
      targetCompanyUuid?: string | null;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/hire/resolveCanonicalCompany',
    });
  }

  /**
   * Find many documents (with filtering, projection, pagination and limiting).
   * @param filter
   * @returns any One or many users documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServicesecurityProcessesEnterpriseUsers(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<user>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/enterpriseUsers',
      query: {
        'filter': filter,
      },
    });
  }

  /**
   * count users
   * Count users (with filtering, pagination and limiting).
   * @param filter
   * @returns any Count of users documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServicesecurityProcessesEnterpriseUsersCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/enterpriseUsers/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * Invite a user to an enterprise
   * @param requestBody
   * @returns any The newly invited user record
   * @throws ApiError
   */
  public postApiServicesecurityProcessesEnterpriseIdentityInvite(
    requestBody?: {
      enterpriseUuid: string;
      invitations: Array<{
        email: string;
        enterpriseRoleUuid?: string;
        companyRolePairs: Array<{
          companyUuid: string;
          roleUuid: string;
        }>;
        autoAssignNewCompanies?: boolean;
      }>;
      disableEmailInvite?: boolean;
    },
  ): CancelablePromise<{
    data?: {
      users?: Array<user>;
      /**
       * Users who already existed in a pending (INIT) state and were reissued a fresh registration link instead of causing a conflict.
       */
      reinvited?: Array<user>;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/enterprise-identity/invite',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Modify a user's access to companies in an enterprise
   * @param enterpriseIdentityUuid user enterprise identity identifier
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public putApiServicesecurityProcessesEnterpriseIdentityMembership(
    enterpriseIdentityUuid: string,
    requestBody?: {
      enterpriseUuid: string;
      enterpriseRoleUuid?: string;
      companyRolePairs: Array<{
        companyUuid: string;
        roleUuid: string;
      }>;
      disableEmailInvite?: boolean;
      autoAssignNewCompanies?: boolean;
    },
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/servicesecurity/processes/enterprise-identity/{enterpriseIdentityUuid}/membership',
      path: {
        'enterpriseIdentityUuid': enterpriseIdentityUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Permanently delete an enterprise user and all their company identities
   * @param enterpriseIdentityUuid user enterprise identity identifier
   * @returns void
   * @throws ApiError
   */
  public deleteApiServicesecurityProcessesEnterpriseIdentity(
    enterpriseIdentityUuid: string,
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/servicesecurity/processes/enterprise-identity/{enterpriseIdentityUuid}',
      path: {
        'enterpriseIdentityUuid': enterpriseIdentityUuid,
      },
    });
  }

  /**
   * backfill missing users for external employers
   * @param companyIdentifier company uuid
   * @param requestBody
   * @returns any Backfilled missing users for external employers
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersBackfillMissingUsersForExternalEmployers(
    companyIdentifier: string,
    requestBody?: {
      /**
       * The number of users to backfill in each batch
       */
      batchSize?: number;
    },
  ): CancelablePromise<{
    meta?: responsesPartMeta;
    success?: boolean;
    backfilled?: number;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/backfillMissingUsersForExternalEmployers/{companyIdentifier}',
      path: {
        'companyIdentifier': companyIdentifier,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * refresh user token
   * Refresh user access token using a refresh token.
   * @param requestBody
   * @returns any A payload with a refreshed access token and a new refresh token
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUsersTokenRefresh(
    requestBody?: {
      token: string;
    },
  ): CancelablePromise<{
    data?: {
      token?: string;
      refreshToken?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/users/token/refresh',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Exchange a super user token for a company system user token
   * @param companyIdentifier company uuid
   * @returns any A payload with up to four information: `exists` boolean, true if the user is found, `connected` boolean, true if the login is successful, `token` string, the JWT token if login is successful, `userUuid` string, the user's uuid
   * @throws ApiError
   */
  public postApiServicesecurityProcessesSuperusersIssueCompanyToken(
    companyIdentifier: string,
  ): CancelablePromise<{
    data?: {
      exists?: boolean;
      connected?: boolean;
      token?: string;
      userUuid?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/superusers/issueCompanyToken/{companyIdentifier}',
      path: {
        'companyIdentifier': companyIdentifier,
      },
    });
  }

  /**
   * Filtered list of system company identities super users can use
   * @param filter
   * @returns any A list of system company identities
   * @throws ApiError
   */
  public getApiServicesecurityProcessesSuperusersCompanyIdentities(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<{
      userUuid?: string;
      company?: {
        uuid?: string;
        name?: string;
        mainLogoUrl?: string;
        companyType?: 'active' | 'internal' | 'pilot' | 'demo';
      };
    }>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/superusers/companyIdentities',
      query: {
        'filter': filter,
      },
    });
  }

  /**
   * Authentify user for intercom
   * @param token auth token
   * @returns any The HMAC value for the user email address
   * @throws ApiError
   */
  public getApiServicesecurityProcessesIntercomHmac(
    token: string,
  ): CancelablePromise<{
    data?: {
      hash?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/intercom/hmac',
      query: {
        'token': token,
      },
    });
  }

  /**
   * Compiles WX user access information for Omni for the authenticated user
   * @param hireAccountUuid hireAccountUuid
   * @param omniPayload whether the result is bound for an omni embed request, in which case a company opt-out from opening audiences applies. Callers that feed the Cue agent leave this off
   * @returns any A summary of pertinent WX access information associated with the user
   * @throws ApiError
   */
  public getApiServicesecurityProcessesUserHireOmniWxUserAccess(
    hireAccountUuid: string,
    omniPayload: boolean = false,
  ): CancelablePromise<{
    data?: {
      first_name?: string;
      last_name?: string;
      company_identifier?: string;
      user_unique_identifier?: string;
      dataset_base_domain?: string;
      wx_user_uuid?: string;
      wx_company_uuid?: string;
      email_address?: string;
      fountain_product_access?: Array<string>;
      wx_permission_uuids?: Array<string>;
      wx_is_admin?: boolean;
      wx_role?: string;
      analytics_access?: 'off' | 'custom_reporting' | 'analytics_view_only';
      wx_can_view_i9_audit_analytics?: boolean;
      can_see_sensitive_pii?: boolean;
      can_view_users?: boolean;
      analytics_shared_folder_access?: 'NO_ACCESS' | 'MANAGER' | 'EDITOR' | 'VIEWER';
      wx_location_restricted?: boolean;
      wx_security_group_restricted?: boolean;
      wx_base_domain?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/user/hire/omni/{hireAccountUuid}/wxUserAccess',
      path: {
        'hireAccountUuid': hireAccountUuid,
      },
      query: {
        'omniPayload': omniPayload,
      },
    });
  }

  /**
   * Compiles WX user access information for Omni using an API-key and a user email
   * @param hireAccountUuid hireAccountUuid
   * @param email email of user
   * @param xApiKey
   * @param omniPayload whether the result is bound for an omni embed request, in which case a company opt-out from opening audiences applies. Callers that feed the Cue agent leave this off
   * @returns any A summary of pertinent WX access information associated with the user
   * @throws ApiError
   */
  public getApiServicesecurityProcessesUserHireOmniWxUserAccess1(
    hireAccountUuid: string,
    email: string,
    xApiKey: string,
    omniPayload: boolean = false,
  ): CancelablePromise<{
    data?: {
      first_name?: string;
      last_name?: string;
      company_identifier?: string;
      user_unique_identifier?: string;
      dataset_base_domain?: string;
      wx_user_uuid?: string;
      wx_company_uuid?: string;
      email_address?: string;
      fountain_product_access?: Array<string>;
      wx_permission_uuids?: Array<string>;
      wx_is_admin?: boolean;
      wx_role?: string;
      analytics_access?: 'off' | 'custom_reporting' | 'analytics_view_only';
      wx_can_view_i9_audit_analytics?: boolean;
      can_see_sensitive_pii?: boolean;
      can_view_users?: boolean;
      analytics_shared_folder_access?: 'NO_ACCESS' | 'MANAGER' | 'EDITOR' | 'VIEWER';
      wx_location_restricted?: boolean;
      wx_security_group_restricted?: boolean;
      wx_base_domain?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/user/hire/omni/{hireAccountUuid}/wxUserAccess/{email}',
      path: {
        'hireAccountUuid': hireAccountUuid,
        'email': email,
      },
      headers: {
        'X-API-KEY': xApiKey,
      },
      query: {
        'omniPayload': omniPayload,
      },
    });
  }

  /**
   * Get product feature access and navigation configuration for the authenticated user
   * @returns any User product feature access information
   * @throws ApiError
   */
  public getApiServicesecurityProcessesUsersProductFeatureAccess(): CancelablePromise<{
    data?: {
      productAccess: Array<{
        /**
         * Product name
         */
        key: 'assist' | 'analytics' | 'compliance' | 'compliancev2' | 'communicate' | 'hire' | 'hire_go' | 'i9' | 'i9_v2' | 'learn' | 'onboard' | 'orchestra' | 'pay' | 'pool' | 'pulse' | 'reach' | 'referral' | 'shift' | 'source' | 'support' | 'universal_dashboard';
        /**
         * Whether the user has access to this product
         */
        enabled: boolean;
        /**
         * Sub-menu items for this product
         */
        children: Array<{
          /**
           * Sub-menu item name
           */
          key: string;
          /**
           * Whether the user can access this sub-menu item
           */
          enabled: boolean;
        }>;
      }>;
      /**
       * Secondary navigation access
       */
      secondarySccess?: Array<{
        /**
         * Secondary navigation item name
         */
        key: string;
        /**
         * Whether the user can access this secondary navigation item
         */
        enabled: boolean;
        /**
         * Sub-items for this secondary navigation item
         */
        children: Array<{
          /**
           * Sub-item name
           */
          key: string;
          /**
           * Whether the user can access this sub-item
           */
          enabled: boolean;
        }>;
      }>;
      /**
       * Dropdown menu access configuration
       */
      dropdownAccess: Array<{
        /**
         * Dropdown menu item name
         */
        key: 'settings' | 'profile' | 'academy' | 'help-center' | 'logout';
        /**
         * Whether the user can access this dropdown menu item
         */
        enabled: boolean;
        /**
         * Sub-items for this dropdown menu item
         */
        children: Array<{
          /**
           * Sub-item name
           */
          key: string;
          /**
           * Whether the user can access this sub-item
           */
          enabled: boolean;
        }>;
      }>;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/users/productFeatureAccess',
      errors: {
        400: `Bad Request - Missing required parameters`,
        401: `Unauthorized - Missing or invalid authentication`,
        404: `Not Found - User or company not found`,
        422: `Unprocessable Entity - Error retrieving user access`,
      },
    });
  }

  /**
   * Get enabled product keys for the authenticated account (MCP v2)
   * @param requestBody
   * @returns any Enabled product keys for this account
   * @throws ApiError
   */
  public postApiServicesecurityProcessesMcpUsersProductAccess(
    requestBody?: {
      /**
       * UUID of the authenticated user
       */
      userUuid?: string;
      /**
       * UUID of the company
       */
      companyUuid?: string;
    },
  ): CancelablePromise<{
    data?: {
      /**
       * Comma-separated product keys enabled for this account
       */
      enabledProducts: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/mcp/users/product-access',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get user product feature access and navigation configuration for a specific user
   * @param userIdentifier The UUID of the user to get product feature access for
   * @returns any User product feature access information
   * @throws ApiError
   */
  public getApiServicesecurityProcessesUsersProductFeatureAccess1(
    userIdentifier: string,
  ): CancelablePromise<{
    data?: {
      productAccess: Array<{
        /**
         * Product name
         */
        key: 'assist' | 'analytics' | 'compliance' | 'compliancev2' | 'communicate' | 'hire' | 'hire_go' | 'i9' | 'i9_v2' | 'learn' | 'onboard' | 'orchestra' | 'pay' | 'pool' | 'pulse' | 'reach' | 'referral' | 'shift' | 'source' | 'support';
        /**
         * Whether the user has access to this product
         */
        enabled: boolean;
        /**
         * Sub-menu items for this product
         */
        children: Array<{
          /**
           * Sub-menu item name
           */
          key: string;
          /**
           * Whether the user can access this sub-menu item
           */
          enabled: boolean;
        }>;
      }>;
      /**
       * Secondary navigation access
       */
      secondarySccess?: Array<{
        /**
         * Secondary navigation item name
         */
        key: string;
        /**
         * Whether the user can access this secondary navigation item
         */
        enabled: boolean;
        /**
         * Sub-items for this secondary navigation item
         */
        children: Array<{
          /**
           * Sub-item name
           */
          key: string;
          /**
           * Whether the user can access this sub-item
           */
          enabled: boolean;
        }>;
      }>;
      /**
       * Dropdown menu access configuration
       */
      dropdownAccess: Array<{
        /**
         * Dropdown menu item name
         */
        key: 'settings' | 'profile' | 'academy' | 'help-center' | 'logout';
        /**
         * Whether the user can access this dropdown menu item
         */
        enabled: boolean;
        /**
         * Sub-items for this dropdown menu item
         */
        children: Array<{
          /**
           * Sub-item name
           */
          key: string;
          /**
           * Whether the user can access this sub-item
           */
          enabled: boolean;
        }>;
      }>;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/users/{userIdentifier}/productFeatureAccess',
      path: {
        'userIdentifier': userIdentifier,
      },
      errors: {
        400: `Bad Request - Missing required parameters`,
        401: `Unauthorized - Missing or invalid authentication`,
        404: `Not Found - User or company not found`,
        422: `Unprocessable Entity - Error retrieving user access`,
      },
    });
  }

  /**
   * Echo back the user's info
   * @returns any A summary of pertinent identification data associated with the user
   * @throws ApiError
   */
  public getApiServicesecurityProcessesUserWhoami(): CancelablePromise<{
    data?: {
      uuid?: string;
      companyUuid?: string;
      enterpriseUuid?: string;
      enterpriseIdentityUuid?: string;
      audience?: string;
      audienceUuid?: string;
      authzRoleUuid?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/user/whoami',
    });
  }

  /**
   * Get employers with roles
   * Returns all employer users for the company with employerUuid, employerName, role and restricted array. Company is taken from auth context.
   * @returns any Employers with roles
   * @throws ApiError
   */
  public getApiServicesecurityProcessesEmployersWithRoles(): CancelablePromise<{
    data?: Array<{
      employerUuid?: string;
      employerName?: string;
      userUuid?: string;
      roleUuid?: string;
      roleLabel?: string;
      restricted?: Array<string>;
    }>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/employers/with-roles',
      errors: {
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Get WX permission UUIDs and company UUID for authenticated user
   * Returns wx_permission_uuids (array of location/security group UUIDs or [-1000]) and wx_company_uuid. Used by FAI backend to get user permissions for WX-only context (no Hire data), the Oxy "ask-sync" agent.
   * @returns any User WX permissions successfully retrieved
   * @throws ApiError
   */
  public getApiServicesecurityProcessesUserWxPermissions(): CancelablePromise<{
    data?: {
      /**
       * Array of audience location and security group UUIDs. Returns [-1000] if user has no role restrictions.
       */
      wx_permission_uuids: Array<string>;
      /**
       * UUID of the user company
       */
      wx_company_uuid: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/user/wxPermissions',
      errors: {
        401: `Unauthorized - Missing or invalid authentication`,
        404: `Not Found - User or role not found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Authenticate kiosk mode login
   * @param requestBody
   * @returns any Authentication successful
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserKioskAuthenticate(
    requestBody: {
      locationUuids: Array<string>;
    },
  ): CancelablePromise<{
    data?: {
      success?: boolean;
      /**
       * JWT token for kiosk mode access
       */
      token?: string;
      locationUuids?: Array<string>;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/kiosk/authenticate',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Invalid credentials`,
      },
    });
  }

  /**
   * Authenticate a worker within kiosk mode
   * @param requestBody
   * @returns any Worker authenticated successfully
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserKioskWorkerLogin(
    requestBody: {
      /**
       * The value of the worker field to match (e.g., phone number, employee ID). This is the identifier the worker provides.
       */
      workerFieldValue: string;
      /**
       * The worker field path to search by. Must be one of the configured worker login methods from general settings (WorkerLoginMethod enum).
       */
      workerFieldPath: 'mobilePhone.number' | 'externalId';
      /**
       * The location UUID for the kiosk
       */
      locationUuid?: string;
    },
  ): CancelablePromise<{
    data?: {
      success?: boolean;
      workerToken?: string;
      worker?: {
        uuid?: string;
        slug?: string;
      };
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/kiosk/worker-login',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid credentials or missing parameters`,
        401: `Unauthorized - not in kiosk mode`,
      },
    });
  }

  /**
   * Get currently active worker in kiosk mode
   * @returns any Active worker information retrieved
   * @throws ApiError
   */
  public getApiServicesecurityProcessesUsersKioskActiveWorker(): CancelablePromise<{
    data?: {
      hasActiveWorker?: boolean;
      worker?: {
        uuid?: string;
        email?: string;
        firstName?: string;
        lastName?: string;
      };
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/users/kiosk/active-worker',
      errors: {
        401: `Not in kiosk mode`,
      },
    });
  }

  /**
   * invite employer user with immediate role assignment
   * Creates a user with role first, then triggers reactive employer creation
   * @param requestBody
   * @returns any User successfully created with role
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserInviteEmployer(
    requestBody: {
      /**
       * Email address of the user to invite
       */
      email: string;
      /**
       * First name of the user to invite
       */
      firstname?: string;
      /**
       * Last name of the user to invite
       */
      lastname?: string;
      /**
       * UUID of the company to invite the user to
       */
      companyUuid: string;
      /**
       * UUID of the user sending the invitation
       */
      invitedByUserUuid: string;
      /**
       * If false, user will not receive the initial welcome message when they first enter the WX system
       */
      invitationMessageEnabled?: boolean;
      /**
       * UUID of the role to assign (optional, will use default if not provided)
       */
      authzRoleUuid: string;
      /**
       * Timezone of the user to invite
       */
      timezone?: string;
      /**
       * Locale of the user to invite
       */
      locale?: string;
      /**
       * External source of the user to invite
       */
      externalSource?: 'hire' | 'hire-go' | 'workday' | 'kombo';
      /**
       * If true, skips the check for existing email on Hire system (default: false)
       */
      skipHireEmailCheck?: boolean;
      /**
       * Desired status for the created user. When provided, overrides the status derived from invitationMessageEnabled.
       */
      targetEmployerStatus?: string;
    },
  ): CancelablePromise<{
    data?: {
      uuid?: string;
      audienceUuid?: string;
      email?: string;
      firstname?: string;
      lastname?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/invite-employer',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid credentials or missing parameters`,
        401: `Unauthorized`,
        409: `Conflict - a user with this email already exists`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * add integration user with immediate role assignment
   * Creates a user with role first, then triggers reactive employer creation
   * @param requestBody
   * @returns any User successfully created with role
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserIntegrations(
    requestBody: {
      /**
       * Name of the integration
       */
      integrationName: string;
      /**
       * UUID of the role to assign (optional, will use default if not provided)
       */
      authzRoleUuid: string;
    },
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/integrations',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid credentials or missing parameters`,
        401: `Unauthorized`,
        422: `Unprocessable Entity - user already exists`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * find the worker profiles of a company matching an email or phone and send a confirmation link to that identifier
   * @param requestBody
   * @returns any Always sent:true for a valid company — the response does not reveal whether any profile matched the identifier
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserProfilesDiscover(
    requestBody?: {
      companySlug: string;
      /**
       * email address or phone number
       */
      identifier: string;
      turnstileToken?: string;
    },
  ): CancelablePromise<{
    data?: {
      sent?: boolean;
      identifierType?: string;
      obfuscatedIdentifier?: string;
      expiresInMinutes?: number;
      /**
       * local/dev environments only
       */
      discoveryLink?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/profiles/discover',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * verify a profile discovery link and list the matching worker profiles
   * @param requestBody
   * @returns any The worker profiles matching the verified identifier
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserProfilesVerify(
    requestBody?: {
      companySlug: string;
      clientCode: string;
      token: string;
    },
  ): CancelablePromise<{
    data?: {
      profiles?: Array<{
        workerSlug?: string;
        firstname?: string;
        lastname?: string;
        displayFullName?: string;
        avatar?: string;
        employmentStatus?: string;
        startDate?: string;
        /**
         * Only on terminated profiles — the day employment ended. An inactive profile (leave, suspension, seasonal, furlough) is still employed and carries no end date.
         */
        endedAt?: string;
        jobName?: string;
        locationNames?: Array<string>;
        isCurrent?: boolean;
        /**
         * Present only on a profile that signs in through the company identity provider. Send the worker here — login and switch both refuse this profile, since a verified email is not an IdP assertion.
         */
        ssoLoginUrl?: string;
      }>;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/profiles/verify',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * exchange a verified profile discovery link and a chosen profile for a personal page token consumable by the worker login page
   * @param requestBody
   * @returns any A personal page token for the chosen profile, to be consumed by the standard worker login page ('?t=' parameter)
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserProfilesLogin(
    requestBody?: {
      companySlug: string;
      clientCode: string;
      token: string;
      workerSlug: string;
    },
  ): CancelablePromise<{
    data?: {
      userUuid?: string;
      workerSlug?: string;
      token?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/profiles/login',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * list the authenticated worker's sibling profiles (same company, same email or phone)
   * @returns any The worker profiles of the same person in this company, including the current one (isCurrent: true). canSwitch is true only for sessions established through the multi-profile discovery flow; other sessions only ever see their own profile.
   * @throws ApiError
   */
  public getApiServicesecurityProcessesUserProfiles(): CancelablePromise<{
    data?: {
      canSwitch?: boolean;
      profiles?: Array<{
        workerSlug?: string;
        firstname?: string;
        lastname?: string;
        displayFullName?: string;
        avatar?: string;
        employmentStatus?: string;
        startDate?: string;
        /**
         * Only on terminated profiles — the day employment ended. An inactive profile (leave, suspension, seasonal, furlough) is still employed and carries no end date.
         */
        endedAt?: string;
        jobName?: string;
        locationNames?: Array<string>;
        isCurrent?: boolean;
        /**
         * Present only on a profile that signs in through the company identity provider. Send the worker here — login and switch both refuse this profile, since a verified email is not an IdP assertion.
         */
        ssoLoginUrl?: string;
      }>;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/user/profiles',
    });
  }

  /**
   * issue a personal page token for a sibling profile of the authenticated worker
   * @param requestBody
   * @returns any A personal page token for the sibling profile, to be consumed by the standard worker login page ('?t=' parameter)
   * @throws ApiError
   */
  public postApiServicesecurityProcessesUserProfilesSwitch(
    requestBody?: {
      workerSlug: string;
    },
  ): CancelablePromise<{
    data?: {
      userUuid?: string;
      workerSlug?: string;
      token?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/user/profiles/switch',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
